import { cookie } from 'shared-kernel/helpers';

export default window.location.hostname === 'localhost' || cookie.get('__dev');